module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iglobal"
  }, [_c('div', {
    staticClass: "iglobal_main_page"
  }, [_c('div', {
    ref: "mybox",
    staticClass: "detail_slide_1"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "40%",
      "left": "0",
      "right": "0",
      "bottom": "0"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticClass: "ichat_banner_title"
  }, [_vm._v("iGlobal")]), _vm._v(" "), _c('p', {
    staticClass: "details_banner_text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('iglobal_details_page_title')) + "\n                        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout-content",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "Product-content mogos"
  }, [_c('div', {
    staticClass: "Product-content",
    staticStyle: {
      "background": "#FFFFFF",
      "padding": "5% 0 5% 0"
    }
  }, [_c('Row', {
    staticStyle: {
      "padding": "0 3% 0 3%"
    }
  }, [_c('Col', {
    staticClass: "Product-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md": 13
    }
  }, [_c('img', {
    staticClass: "mogos-logo",
    attrs: {
      "src": require("../../assets/store/iGlobal_card.png")
    }
  })]), _vm._v(" "), _c('Col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": 11
    }
  }, [_c('p', {
    staticClass: "Product-name"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('iglobal_details_page_product_title')) + "\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "Product-price"
  }, [_vm._v("\n                                $" + _vm._s(_vm.goods_info.goods_price) + "\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "Product-details"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('iglobal_details_page_product_content')) + "\n                            ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_product_parameters1')) + "\n                                ")]), _vm._v(" "), _c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_product_parameters2')) + "\n                                ")]), _vm._v(" "), _c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_product_parameters3')) + "\n                                ")])]), _vm._v(" "), _c('buy', {
    attrs: {
      "id": parseInt(_vm.$route.params.id),
      "maxCount": parseInt(_vm.goods_info.store_count)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-content speedy"
  }, [_c('div', {
    staticStyle: {
      "background": "rgba(31,45,61,0.3)",
      "padding": "25px 0 25px 0"
    }
  }, [_c('Row', {
    staticClass: "details-card",
    attrs: {
      "gutter": 30
    }
  }, [_c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon1.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content1_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content1_2')))])])])], 1), _vm._v(" "), _c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon2.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content2_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content2_2')))])])])], 1), _vm._v(" "), _c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon3.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content3_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content3_2')))])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon4.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content4_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content4_2')))])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon5.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content5_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content5_2')))])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon6.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content6_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage1_content6_2')))])])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "details_iapp_banner"
  }, [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticClass: "layout-conten",
    attrs: {
      "id": "iglobal_phone"
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('i-col', {
    staticStyle: {
      "position": "absolute",
      "top": "0"
    },
    attrs: {
      "xs": 24,
      "sm": {
        span: 12,
        offset: 12
      },
      "md": {
        span: 12,
        offset: 11
      },
      "lg": {
        span: 12,
        offset: 11
      }
    }
  }, [_c('p', {
    staticClass: "details_iapp_text details_iapp_text1"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('iglobal_details_advantage2')) + "\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "details_iapp_text details_iapp_text2"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('mogos_details_page_advantage2_content')) + "\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide slider1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "slider1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide slider2",
    attrs: {
      "id": "slider2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide slider3",
    attrs: {
      "id": "slider3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12",
      "offset": "12"
    }
  }, [_c('p', {
    staticClass: "details_iapp_text",
    staticStyle: {
      "font-size": "50px",
      "color": "#1F2D3D",
      "line-height": "78px"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('mogos_details_page_advantage2')) + "\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "details_iapp_text",
    staticStyle: {
      "font-size": "22px",
      "color": "#5E6D82",
      "line-height": "40px"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('mogos_details_page_advantage2_content')) + "\n                                        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-iglobal-phone",
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticClass: "details_iapp_text details_iapp_text1"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('mogos_details_page_advantage2')) + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "details_iapp_text details_iapp_text2"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('mogos_details_page_advantage2_content')) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "iglobal-step"
  }, [_c('p', {
    staticClass: "Product-smname"
  }, [_vm._v("1." + _vm._s(_vm.$t('igobal_tip1')))]), _vm._v(" "), (this.mogosLang == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/iglobal_phone_1_cn.jpg"),
      "alt": "iglobal-step-1"
    }
  }) : (this.mogosLang == 'cn') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/iglobal_phone_1_en.png"),
      "alt": "iglobal-step-1"
    }
  }) : (this.mogosLang == 'tc') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/iglobal_phone_1_cn.jpg"),
      "alt": "iglobal-step-1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "iglobal-step"
  }, [_c('p', {
    staticClass: "Product-smname"
  }, [_vm._v("2." + _vm._s(_vm.$t('igobal_tip2')))]), _vm._v(" "), (this.mogosLang == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/card_en.png"),
      "alt": "iglobal-step-2"
    }
  }) : (this.mogosLang == 'cn') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/card_cn.png"),
      "alt": "iglobal-step-1"
    }
  }) : (this.mogosLang == 'tc') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/card_tc.png"),
      "alt": "iglobal-step-1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "iglobal-step"
  }, [_c('p', {
    staticClass: "Product-smname"
  }, [_vm._v("3." + _vm._s(_vm.$t('igobal_tip3')))]), _vm._v(" "), (this.mogosLang == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/iglobal_phone_1.png"),
      "alt": "iglobal-step-3"
    }
  }) : (this.mogosLang == 'cn') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/iglobal_phone_1_cn.png"),
      "alt": "iglobal-step-1"
    }
  }) : (this.mogosLang == 'tc') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/iglobal_phone_1_tc.png"),
      "alt": "iglobal-step-1"
    }
  }) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Product-content detials_purchase",
    staticStyle: {
      "padding": "10% 3% 5% 3%"
    }
  }, [_c('Row', {
    staticStyle: {
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_c('i-col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": 13
    }
  }, [_c('p', {
    staticClass: "Product-name",
    staticStyle: {
      "color": "#fff",
      "padding-top": "20px"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('iglobal_details_page_advantage2')) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "Product-details",
    staticStyle: {
      "color": "#fff",
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage2_content1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('iglobal_details_page_advantage2_content2')))])]), _vm._v(" "), _c('button', {
    staticClass: "Product-btn",
    staticStyle: {
      "color": "#fff",
      "background-color": "#ccc",
      "border": "none"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('store_mainpage_out_of_stock')) + "\n                                ")])]), _vm._v(" "), _c('i-col', {
    staticClass: "Product-left",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": 11
    }
  }, [_c('div', {
    staticClass: "iglobal_Cost"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('iglobal_rate_tittle')))]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "cost_input"
  }, [_c('label', [_vm._v("\n                                                " + _vm._s(_vm.$t('iglobal_rate_location')) + "\n                                            ")]), _vm._v(" "), _c('div', {
    staticClass: "cost_input_wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from),
      expression: "from"
    }],
    attrs: {
      "type": "text",
      "name": "from",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.from)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.from = $event.target.value
      }, _vm.inputFunc]
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fromShow),
      expression: "fromShow"
    }]
  }, _vm._l((_vm.from_list), function(list, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.rate_from(list.name)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(list.name))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "cost_input"
  }, [_c('label', [_vm._v("\n                                                " + _vm._s(_vm.$t('iglobal_rate_destination')) + "\n                                            ")]), _vm._v(" "), _c('div', {
    staticClass: "cost_input_wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.to),
      expression: "to"
    }],
    attrs: {
      "type": "text",
      "name": "to",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.to)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.to = $event.target.value
      }, _vm.inputTo]
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow),
      expression: "toShow"
    }]
  }, _vm._l((_vm.to_list), function(list, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.rate_to(list.name)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(list.name))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "cost_btn"
  }, [_c('button', {
    on: {
      "click": _vm.GetRate
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('iglobal_check')) + "\n                                        ")])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('iglobal_details')))]), _vm._v(" "), _c('div', {
    staticClass: "cost_result"
  }, [_c('div', {
    staticClass: "cost_resule_item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/icon_receivecall@2x.png"),
      "width": "50"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cost_type"
  }, [_vm._v(_vm._s(_vm.$t('iglobal_call')))]), _vm._v(" "), (this.cost_data == '') ? _c('p', {
    staticClass: "cost_num"
  }, [_vm._v("00.00")]) : _c('p', {
    staticClass: "cost_num"
  }, [_vm._v(_vm._s(_vm.cost_data.Incoming))]), _vm._v(" "), _c('p', {
    staticClass: "cost_data"
  }, [_vm._v("/min")])]), _vm._v(" "), _c('div', {
    staticClass: "cost_resule_item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/icon_call_out@2x.png"),
      "width": "50"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cost_type"
  }, [_vm._v(_vm._s(_vm.$t('iglobal_callout')))]), _vm._v(" "), (this.cost_data == '') ? _c('p', {
    staticClass: "cost_num"
  }, [_vm._v("00.00")]) : _c('p', {
    staticClass: "cost_num"
  }, [_vm._v(_vm._s(_vm.cost_data.Voice))]), _vm._v(" "), _c('p', {
    staticClass: "cost_data"
  }, [_vm._v("/min")])]), _vm._v(" "), _c('div', {
    staticClass: "cost_resule_item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/icon_sms@2x.png"),
      "width": "50"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cost_type"
  }, [_vm._v(_vm._s(_vm.$t('iglobal_sms')))]), _vm._v(" "), (this.cost_data == '') ? _c('p', {
    staticClass: "cost_num"
  }, [_vm._v("00.00")]) : _c('p', {
    staticClass: "cost_num"
  }, [_vm._v(_vm._s(_vm.cost_data.SMS))]), _vm._v(" "), _c('p', {
    staticClass: "cost_data"
  }, [_vm._v("/sms")])]), _vm._v(" "), _c('div', {
    staticClass: "cost_resule_item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/icon_data@2x.png"),
      "width": "50"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cost_type"
  }, [_vm._v(_vm._s(_vm.$t('iglobal_data')))]), _vm._v(" "), (this.cost_data == '') ? _c('p', {
    staticClass: "cost_num"
  }, [_vm._v("00.00")]) : _c('p', {
    staticClass: "cost_num"
  }, [_vm._v(_vm._s(_vm.cost_data.Data))]), _vm._v(" "), _c('p', {
    staticClass: "cost_data"
  }, [_vm._v("/1mb")])])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "igo-product-details-footer"
  }, [_c('p', {
    staticStyle: {
      "color": "#0084ff"
    }
  }, [_vm._v(_vm._s(_vm.$t('shopping_notes')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('shopping_notes_tip')))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-basis max_width"
  }, [_c('guess')], 1)])])])]), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-551f29bb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetails/iglobal.vue
// module id = 814
// module chunks = 0